import React from 'react';
import { useLoggedInUser } from '../../app/hooks/useLoggedInUser';
import CustomerBrandTable from './CustomerBrands/CustomerBrandTable';
import TenantBrandTable from './TenantBrands/TenantBrandTable';

const BrandsTab: React.FC = () => {
    const { isTenantUser, isCustomerUser } = useLoggedInUser();

    if (isTenantUser) {
        return <TenantBrandTable />;
    }

    if (isCustomerUser) {
        return <CustomerBrandTable />;
    }

    return null;
};

export default BrandsTab;
